// Lista do filtro de nome de sala, nome de trio e apelido: palavrões, termos sexuais e ofensas discriminatórias.
// Revisão do Diego: acrescente ou tire termos aqui; o teste confere que nomes comuns da mesa continuam passando.
// Escreva cada termo como se fala, com ou sem acento: a comparação normaliza os dois lados.

// Trechos: recusam o nome se aparecerem em qualquer parte, inclusive colados ou com letras espaçadas.
// Só termos longos e sem uso inocente dentro de outras palavras.
export const TRECHOS: readonly string[] = [
  'caralho', 'merda', 'buceta', 'boceta', 'xoxota', 'xereca', 'piroca', 'punheta', 'siririca', 'boquete',
  'putaria', 'puteiro', 'arrombad', 'filhodaputa', 'filhadaputa', 'foder', 'fuder', 'fodase', 'fudido', 'fodido',
  'vagabunda', 'prostitut', 'suruba', 'pornografi', 'estupr', 'pedofil', 'escrot',
  'boiola', 'baitola', 'sapatao', 'traveco', 'retardad', 'mongoloide',
  'nazista', 'hitler', 'fuck', 'bitch',
];

// Palavras inteiras: recusam só a palavra sozinha (ou com plural, aumentativo e diminutivo), porque aparecem
// dentro de palavras comuns (computador, curso, porão, desviado, canal, "Truco por nós", "Dani Gamer", fagote).
export const PALAVRAS: readonly string[] = [
  'puta', 'putinha', 'porra', 'cu', 'cuzao', 'foda', 'fode', 'pica', 'cacete', 'bosta', 'vadia', 'crioulo',
  'viado', 'viada', 'viadao', 'viadinho', 'viadinha', 'bicha', 'bichona', 'bichinha',
  'anal', 'anus', 'penis', 'vagina', 'tesao', 'sexo', 'gozada', 'xota', 'shit', 'cunt',
  'fdp', 'pqp', 'vsf', 'tnc', 'vtnc', 'tmnc', 'piroquinha', 'piroquinho',
  'porno', 'nigger', 'nigga', 'faggot',
];

// Terminações coladas na palavra inteira que ainda contam como ela (cus, cuzinho, porras). Formas que trocam a
// última letra (viadão, bichona) entram por extenso na lista acima.
export const TERMINACOES: readonly string[] = ['', 's', 'ao', 'oes', 'ona', 'onas', 'inho', 'inha', 'inhos', 'inhas', 'zao', 'zinho', 'zinha'];

// Raízes que perdem a última letra no diminutivo e no aumentativo (merd + inha, put + ona). Contam só como palavra
// inteira, com uma das flexões abaixo. Ficam de fora de propósito: porrão (igual a porão depois de normalizar),
// porrinha (o jogo de palitinho) e bichinho (animalzinho).
export const RAIZES: readonly string[] = [
  'merd', 'caralh', 'bost', 'cacet', 'put', 'bucet', 'bocet', 'xot', 'xoxot', 'xerec', 'punhet', 'boquet', 'piroc',
  'fodid', 'fudid', 'viad',
];

export const FLEXOES: readonly string[] = ['inho', 'inha', 'inhos', 'inhas', 'ao', 'oes', 'ona', 'onas'];
